export const MAIN_PARA = "জি বাংলার ২৪-তম জন্মদিন উপলক্ষে, আমরা উদযাপন করছি ২৪ ক্যারেট বিনোদন । আমাদের এই দীর্ঘ পথচলাকে উজ্জ্বল করে তুলেছে আপনাদের আর আমাদের সোনার সম্পর্ক। তাই, আপনার জন্য রয়েছে আমাদের তরফ থেকে বিশেষ সারপ্রাইজ!"

export const MAIN_PARA_SUB_HEADING = "সারপ্রাইজ পেতে সিলেক্ট করুন পছন্দের চরিত্র :"
export const NAME_HINT = "আপনার নাম:"
export const AGE_HINT = "বয়স"
export const GENDER_HINT = "লিঙ্গ:"
// export const THANKYOU_HINT = `ধন্যবাদ আপনার তথ্য প্রদান করার জন্য। জ়ি বাংলার পক্ষ থেকে আপনার জন্য থাকছে এক বিশেষ সারপ্রাইজ!  সঙ্গে থাকুন।`
export const THANKYOU_HINT = `Thank you for visiting. This campaign is now over.`
export const WHATSAPP_HINT = "WhatsApp নম্বর :"
export const STATE_HINT = "রাজ্যের নাম:"
export const BUTTON_NAME = "Register করুন"
export const API_KEY = "oNKxm2Lhga4bpripl4I6Z9lrgYqMx5yQ5YVeS3KL"
export const URL = "https://bwafdh6amj.execute-api.us-east-2.amazonaws.com/default/zee-app"